"use client";

import React from "react";
import { Instagram, Linkedin, Twitter } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div data-section-id="134625" className="flex flex-col gap-3">
        {[1, 2, 3].map((_, i) => <div key={i} data-index={i} className="h-4 w-20 animate-pulse rounded-md bg-[#d1b88a]/10" />)}
      </div>;
  }
  return <NavigationMenu viewport={false} className="max-w-full justify-start">
      <NavigationMenuList className="flex-col items-start gap-2 space-x-0">
        {menuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i} className="w-full">
            <NavigationMenuLink asChild className="w-full justify-start px-0 py-1 text-[#f7f3f0]/70 hover:bg-transparent hover:text-[#d1b88a] transition-colors focus:bg-transparent focus:text-[#d1b88a]">
              <Link to={item.href || "#"}>{item.label}</Link>
            </NavigationMenuLink>
          </NavigationMenuItem>)}
      </NavigationMenuList>
    </NavigationMenu>;
}
export default function Footer() {
  return <section id="footer" className="bg-[#120d0a] text-[#f7f3f0] pt-16 pb-8">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-2 lg:grid-cols-4">
          {}
          <div className="flex flex-col items-start space-y-6">
            <Link to="/HomePage">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1605600/img/image_p19o0zhc.png" alt="Synergy Sound" className="h-9 w-auto object-contain" />
            </Link>
            <p className="text-sm leading-relaxed text-[#f7f3f0]/70 font-sans">Synergy Sound is Los Angeles’ premier live event band, delivering soulful R&amp;B and timeless classics for milestone events, weddings and corporate galas.</p>
          </div>

          {}
          <div className="flex flex-col space-y-6">
            <h3 className="text-xs font-mono font-semibold tracking-[0.2em] uppercase text-[#d1b88a]">
              Experience
            </h3>
            <MenuProvider menu_id="45">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          

          {}
          <div className="flex flex-col space-y-6">
            <h3 className="text-xs font-mono font-semibold tracking-[0.2em] uppercase text-[#d1b88a]"></h3>
            <div className="flex gap-2">
              <Button variant="ghost" size="icon" className="rounded-full text-[#d1b88a] hover:bg-[#d1b88a]/10 hover:text-[#d1b88a] hover:shadow-[0_0_15px_rgba(209,184,138,0.2)] transition-all duration-300" asChild>
                <Link to="https://instagram.com/synergysoundla" newTab aria-label="Instagram">
                  <Instagram className="size-5" />
                </Link>
              </Button>
              <Button variant="ghost" size="icon" className="rounded-full text-[#d1b88a] hover:bg-[#d1b88a]/10 hover:text-[#d1b88a] hover:shadow-[0_0_15px_rgba(209,184,138,0.2)] transition-all duration-300" asChild>
                <Link to="https://twitter.com" newTab aria-label="Twitter">
                  <Twitter className="size-5" />
                </Link>
              </Button>
              <Button variant="ghost" size="icon" className="rounded-full text-[#d1b88a] hover:bg-[#d1b88a]/10 hover:text-[#d1b88a] hover:shadow-[0_0_15px_rgba(209,184,138,0.2)] transition-all duration-300" asChild>
                <Link to="https://linkedin.com" newTab aria-label="LinkedIn">
                  <Linkedin className="size-5" />
                </Link>
              </Button>
            </div>
          </div>
        </div>

        <div className="mt-16 flex flex-col items-center space-y-6">
          <Separator className="bg-[#d1b88a]/30 h-[1px]" />
          <div className="flex w-full flex-col items-center justify-between gap-4 sm:flex-row">
            <p className="font-mono text-[10px] tracking-wider uppercase text-[#f7f3f0]/40">
              © {new Date().getFullYear()} Synergy Sound. All rights reserved.
            </p>
            <p className="font-serif italic text-[12px] text-[#d1b88a]/60">
              Soulful sounds from the heart of Los Angeles.
            </p>
          </div>
        </div>
      </div>
    </section>;
}